import styled from "styled-components";

const QualificationWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    padding-bottom: 1rem;
`;

export default QualificationWrapper;
